import { memo } from 'react'

import { TextLoader } from '@procurify/ui'

import { NavigationLoaderStyled } from '../styles/NavigationLoaderStyled'
import { NavigationStyled } from '../styles/NavigationStyled'

export const NavigationLoader = memo(() => {
  return (
    <NavigationStyled>
      <NavigationLoaderStyled>
        <div className='nav-icon'>
          <TextLoader width={20} height={20} />
        </div>
        <div className='nav-text'>
          <TextLoader height={12} />
        </div>
      </NavigationLoaderStyled>
      <NavigationLoaderStyled>
        <div className='nav-icon'>
          <TextLoader width={20} height={20} />
        </div>
        <div className='nav-text'>
          <TextLoader height={12} />
        </div>
      </NavigationLoaderStyled>
      <NavigationLoaderStyled>
        <div className='nav-icon'>
          <TextLoader width={20} height={20} />
        </div>
        <div className='nav-text'>
          <TextLoader height={12} />
        </div>
      </NavigationLoaderStyled>
      <NavigationLoaderStyled>
        <div className='nav-icon'>
          <TextLoader width={20} height={20} />
        </div>
        <div className='nav-text'>
          <TextLoader height={12} />
        </div>
      </NavigationLoaderStyled>
    </NavigationStyled>
  )
})
